import { saveAs } from 'file-saver';

export const ContentTypes = Object.freeze({
  CSV: 'text/csv;charset=utf-8;',
});

// Parses a given dataArray into a CSV string
// dataArray is given in form of an array containing an array of strings
// ie. [['value1', 'value2', ...], ['value1', 'value2', ...], ... ]
export function parseIntoCsv(dataArray) {
  return dataArray.map((row) => row
    .map((value) => value.replaceAll('"', '""')) // double quotes need to be escaped
    .map((value) => `"${value}"`) // the resulting string wrapped in quotes
    .join(',')).join('\r\n'); // newline for each of the rows
}

// Generate blob and downloadlink to export the given content
export function downloadBlob(content, contentType, filename) {
  const blob = new Blob([content], { type: contentType });
  saveAs(blob, filename);
}
